import styled from 'styled-components';

export const HelpSectionContainer = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 99999;
`;

export const HelpSectionMain = styled.div`
  width: ${({ $isFrench }) => ($isFrench ? '400px' : '300px')};
  max-width: 100%;
  height: 100vh;
  background: #ffffff;
  position: absolute;
  right: 0;
  top: 0;
`;

export const HelpSectionTopBar = styled.div`
  height: 36px;
  background: #4b286d;
`;

export const HelpSectionCloseButton = styled.div`
  background: none;
  border: 0;
  float: right;
  margin: 0.2rem 1rem;
  cursor: pointer;
  outline: 0;
`;

export const HelpBottomSection = styled.div`
  display: flex;
  flexdirection: column;
  padding: 2rem 4rem;
`;

export const Spacer = styled.div`
  height: 2px;
`;

export const modalStyles = {
  right: 0,
  left: 'auto',
  top: 0,
  maxHeight: '100%',
  height: '100%',
  maxWidth: '300px'
};

export const styleTextBold = {
  fontWeight: 'bold'
};

export const styleInputField = {
  margin: '10px 0'
};

export const stylePage = {
  backgroundColor: '#fff',
  paddingBottom: '20%',
  paddingTop: '30px'
};

export const listStyle = {
  listStyleType: 'circle',
  paddingLeft: '20px'
};

export const Container = styled.div`
  max-width: 90%;
  margin: auto;
  border: 1px solid #4b286d;
  padding: 3rem;
  border-radius: 1rem;
`;
